import { BaseText, BottomButtonsLayout, theme } from 'aimo-ui';

import EmptyView from 'components/account/subscription/EmptyView';
import SubscriptionData from 'components/account/subscription/SubscriptionData';
import SubscriptionFooter from 'components/account/subscription/SubscriptionFooter';
import SubscriptionInfo, {
  StyledLinkText,
} from 'components/account/subscription/SubscriptionInfo';
import CrickleCutCardBackground from 'components/common/CrickleCutCardBackground';
import FeatureFlagsContext from 'context/FeatureFlagsContext';
import useSubscriptions from 'hooks/useSubscriptions';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Linking } from 'react-native';
import { SheetDetailsWrapper, StyledWrapper } from 'styles/ContainerStyles';
import { isWeb } from 'utils/deviceUtils';
import {
  parseFeatureFlagObject,
  SubscriptionLinksDynamicInfo,
} from 'utils/featureFlagUtils';

export const Subscriptions: React.FC = () => {
  const { t } = useTranslation();
  const {
    flags: { subscription_links },
  } = useContext(FeatureFlagsContext);
  const { loadingSubscription, subscription } = useSubscriptions();
  const noSubscriptions = !subscription && !loadingSubscription;
  const subscriptionLinks =
    parseFeatureFlagObject<SubscriptionLinksDynamicInfo>(
      subscription_links,
      'subscription_links'
    );
  const termsLink = subscription?.countryCode
    ? subscriptionLinks[subscription.countryCode]?.terms
    : undefined;

  if (noSubscriptions) {
    return <EmptyView />;
  }

  return (
    <SheetDetailsWrapper pt={isWeb ? 80 : 0}>
      <BottomButtonsLayout
        contentBottom={!loadingSubscription && <SubscriptionFooter />}>
        <StyledWrapper center maxWidth={isWeb ? 600 : undefined}>
          <CrickleCutCardBackground
            backgroundColor={theme.colors.gray50}
            aboveCutView={<SubscriptionInfo loading={loadingSubscription} />}
            belowCutView={<SubscriptionData loading={loadingSubscription} />}
          />
          {termsLink && (
            <>
              <BaseText color={theme.colors.gray300}>
                {`${t('account.aimoSubscription.linkTexts.terms')} `}
                <StyledLinkText
                  color={theme.colors.gray300}
                  onPress={() => Linking.openURL(termsLink)}>
                  {t('account.terms.termsAndConditions')}
                </StyledLinkText>
              </BaseText>
            </>
          )}
        </StyledWrapper>
      </BottomButtonsLayout>
    </SheetDetailsWrapper>
  );
};

export default Subscriptions;
